import { Button, Card, Form, Modal } from "react-bootstrap"
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { SET_MESSAGE } from "../../Actions/Types";

import "../../Assets/scss/components/copy-widget-script-code.scss";
import TourGuide from "../TourGuide";
import getEUCountryList from "../../Helpers/EUCountryList";
import { useSelector } from "react-redux";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import EUServerMigrationPopup from "../EUServerMigrationPopup";
import compareDates from "../../Helpers/DateCompare";
import isGreater from "../../Helpers/DateCompare";

const ReactAppAPIKeyChanges = `${process.env.REACT_APP_API_KEY_CHANGES}`;
const euServerStartDate = `${process.env.REACT_APP_EU_START_DATE}`;

interface PropsTypes {
    widgetAPIKey: string | null, //widget API Key
    widgetPosition: string | null, // widget position
    widgetColor: string | null // widget color
}

// component to display widget embed code
const CopyWidgetScriptCode = (props: PropsTypes) => {

    // get Props
    const { widgetAPIKey, widgetPosition, widgetColor } = props;

    const user = useSelector((store: StoreProptypes) => store.user);
    const currentWebsite = useSelector((store: StoreProptypes) => store.currentWebsite);
    const websiteList = useSelector((store: StoreProptypes) => store.websiteList);


    // Functions
    const { t } = useTranslation();
    const dispatch = useDispatch();

    // States
    const [advanceCodeInfoModel, setAdvanceCodeInfoModel] = useState<boolean>(false);
    const [codeToggle, setCodeToggle] = useState<boolean>(true);  //this was false for unchecked. made true for default check
    const [widgetCode, setWidgetCode] = useState('');
    const [copyCodeSuccess, setCopyCodeSuccess] = useState<boolean>(false);
    const [copyAPICodeSuccess, setCopyAPICodeSuccess] = useState<boolean>(false);
    const getEUCoutryLists = getEUCountryList()


    useEffect(() => {

        let widgetColorFinal: string;

        // check if widget color exists
        if (widgetColor) {
            // check if widget color includes #
            if (widgetColor.indexOf('#')) {
                widgetColorFinal = `#${widgetColor}`;
            } else {
                widgetColorFinal = widgetColor;
            }
        }
        else {
            widgetColorFinal = '#420083';
        }

        // check if wants to display script code for react app
        if (ReactAppAPIKeyChanges === 'true') {
            setWidgetCode(`<script>setTimeout(() => { let aioa_script_tag = document.createElement("script"); aioa_script_tag.src = "${currentWebsite && currentWebsite.no_required_eu === 0 ? `${process.env.REACT_APP_EU_SERVER_URL}` : "https://www.skynettechnologies.com"}/accessibility/js/all-in-one-accessibility-js-widget-minify.js?colorcode=${widgetColorFinal}&position=${widgetPosition ? widgetPosition : 'bottom_right'}"; aioa_script_tag.defer="true"; aioa_script_tag.id = "aioa-adawidget"; document.getElementsByTagName("body")[0].appendChild(aioa_script_tag); }, 3000);</script>`);
        } else {
            // check if advanced code is toggled
            if (codeToggle) {
                setWidgetCode(`<script>setTimeout(() => { let aioa_script_tag = document.createElement("script"); aioa_script_tag.src = "${currentWebsite && currentWebsite.no_required_eu === 0 ? `${process.env.REACT_APP_EU_SERVER_URL}` : "https://www.skynettechnologies.com"}/accessibility/js/all-in-one-accessibility-js-widget-minify.js?colorcode=${widgetColorFinal}&token=${widgetAPIKey}&position=${widgetPosition ? widgetPosition : 'bottom_right'}";  aioa_script_tag.id = "aioa-adawidget";aioa_script_tag.defer="true"; document.getElementsByTagName("body")[0].appendChild(aioa_script_tag); }, 3000);</script>`);
            } else {
                setWidgetCode(`<script id="aioa-adawidget" src="${currentWebsite && currentWebsite.no_required_eu === 0 ? `${process.env.REACT_APP_EU_SERVER_URL}` : "https://www.skynettechnologies.com"}/accessibility/js/all-in-one-accessibility-js-widget-minify.js?colorcode=${widgetColorFinal}&token=${widgetAPIKey}&position=${widgetPosition ? widgetPosition : 'bottom_right'}" defer></script>`);
            }
        }
    }, [codeToggle, widgetAPIKey, widgetPosition, widgetColor, currentWebsite?.no_required_eu])

    // function to display advanced code Model
    const handleShowWidgetAdvanceCodeInfoModel = () => setAdvanceCodeInfoModel(true);

    // function to hide advanced code Model
    const handleHideWidgetAdvanceCodeInfoModel = () => setAdvanceCodeInfoModel(false);


    // function to handle Copy Code to clipboard
    const handleWidgetCopyCode = () => {

        navigator.clipboard.writeText(widgetCode);
        setCopyCodeSuccess(true);

        // dispatch copy success message
        dispatch({
            type: SET_MESSAGE,
            payload: {
                "toast_message": t('Copied'),
                "toast_type": "success"
            }
        });

        setTimeout(() => {
            setCopyCodeSuccess(false);
        }, 5000)
    }

    // function to handle Copy Code to clipboard for token
    const handleWidgetAPICopyCode = () => {
        if (widgetAPIKey) {
            navigator.clipboard.writeText(widgetAPIKey);
            setCopyAPICodeSuccess(true);

            // dispatch copy success message
            dispatch({
                type: SET_MESSAGE,
                payload: {
                    "toast_message": t('Copied'),
                    "toast_type": "success"
                }
            });

            setTimeout(() => {
                setCopyAPICodeSuccess(false);
            }, 5000)
        }

    }

    return (
        <>
            <TourGuide />
            <Card className="aioa_dashboard-copy-widget-code tour-scripts">
                <Card.Body>
                    {(currentWebsite) && ((websiteList.length === 1) || (currentWebsite?.current_package_only && currentWebsite.current_package_only.length > 0 && isGreater(currentWebsite.current_package_only[0].start_date, euServerStartDate))) ? (
                        <>
                            <EUServerMigrationPopup
                                isFromDashboard={true}
                                isFirstTimeLoad={false}
                                widgetAPIKey={(currentWebsite.current_package_only && currentWebsite.current_package_only.length > 0) ? currentWebsite.current_package_only[0].api_key : null}
                                widgetPosition={currentWebsite.widget_position !== null ? currentWebsite.widget_position : `bottom_right`}
                                widgetColor={currentWebsite.widget_color_code !== null ? currentWebsite.widget_color_code : `#420083`}
                            />
                        </>
                    ):(<>
                    </>)}
                    <div className='mb-2'><strong>Step 1</strong> : {t('Copy the following code')}</div>
                    <div className='mb-3'><strong>Step 2</strong> : {t('Insert the code into website footer')}</div>

                    <div className='aioa_dashboard-widget-code'>
                        <div className='aioa_dashboard-widget-code-copy-btn'>
                            <Button aria-label={t("Copy widget embed code").toString()} className='mb-0' variant={`${copyCodeSuccess ? 'success' : 'info'}`} onClick={handleWidgetCopyCode}><i className={`material-symbols-outlined`} aria-hidden="true">{copyCodeSuccess ? 'done' : 'content_copy'}</i></Button>
                        </div>
                        <pre>{widgetCode}</pre>
                    </div>


                    {ReactAppAPIKeyChanges !== 'true' && (
                        <>
                            <div className="aioa_dashboard-widget-code-toggle-header">
                                <div className="aioa_dashboard-widget-code-toggle">
                                    <Form.Check
                                        type="checkbox"
                                        id="code-switch"
                                        label={`${t('Advance Code')}`}
                                        checked={codeToggle}  // Ensure checkbox state is controlled
                                        onChange={() => setCodeToggle(!codeToggle)}
                                    />

                                    <Button variant="outline-primary" onClick={() => handleShowWidgetAdvanceCodeInfoModel()} size="sm" aria-haspopup="true" aria-label={t("Information on Advanced Code")}>
                                        <i className="material-symbols-outlined" aria-hidden="true">info</i>
                                    </Button>

                                    <Modal show={advanceCodeInfoModel} onHide={handleHideWidgetAdvanceCodeInfoModel} centered>
                                        <Modal.Header closeButton>
                                            <Modal.Title>{t('Advance Code')}</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>{t('advance code info text')}</Modal.Body>
                                    </Modal>
                                </div>
                            </div>

                            {/* Integration Script Based on Checked Value */}
                            {codeToggle && (
                                <script>
                                </script>
                            )}
                        </>
                    )}


                </Card.Body>
            </Card>
            {widgetAPIKey && (
                <Card className="aioa_dashboard-copy-widget-code mt-2 w-100">
                    <Card.Body>
                        <div className='mb-2'><strong>{t('License key alternative')}</strong></div>
                         {/* <div className='aioa_dashboard-widget-code mb-1'> */}
                            <p>{t(`We provide free installation support`)}</p>
                        {/* </div> */}
                        <div className='aioa_dashboard-widget-code'>
                            <div className='aioa_dashboard-widget-code-copy-btn'>
                                <Button aria-label={t("Copy widget embed code").toString()} className='mb-0' variant={`${copyAPICodeSuccess ? 'success' : 'info'}`} onClick={handleWidgetAPICopyCode}><i className={`material-symbols-outlined`} aria-hidden="true">{copyAPICodeSuccess ? 'done' : 'content_copy'}</i></Button>
                            </div>
                            <pre>{widgetAPIKey}</pre>
                        </div>

                    </Card.Body>
                </Card>
            )}

        </>
    )
}

export default CopyWidgetScriptCode;
